(function($) {

  initializeOwlCarousel();

setInterval(function() {
        
  $('.owl-carousel').owlCarousel({
        autoplay:false,
        autoplayTimeout:2000,
        autoplayHoverPause:false,
        loop:true,
        margin:10,
        nav:true,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:1
          },
          1000:{
            items:1
          }
        }
      });

    }, 1500);

  // var lastScrollTop = 0;
  
// $(window).scroll(function() {
//     var currentScrollTop = $(this).scrollTop();

//     // Check if the current scroll position is greater than the last scroll position
//     if (currentScrollTop > lastScrollTop) {
//         // User is scrolling down
//         alert(currentScrollTop + " + "  + lastScrollTop);
//     }

//     // Update last scroll position to current scroll position
//     lastScrollTop = currentScrollTop;

// });

//   var lastScrollTop = 0;

// $(window).scroll(function() {
//     var currentScrollTop = $(this).scrollTop();

//     // Check if the user scrolled down more than 100 pixels
//     if (currentScrollTop > lastScrollTop && currentScrollTop - lastScrollTop > 100) {
//         // User scrolled down more than 100 pixels
//         // alert('Scrolled down more than 100 pixels!');
//     }

//     // Update last scroll position to current scroll position
//     lastScrollTop = currentScrollTop;
// });


  }) (jQuery);

function initializeOwlCarousel() {
  $('.owl-carousel').owlCarousel({
        autoplay:false,
        autoplayTimeout:2000,
        autoplayHoverPause:false,
        loop:true,
        margin:10,
        nav:true,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:1
          },
          1000:{
            items:1
          }
        }
      });

    
}